import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductOrder } from "../../../types/admin/productOrder.types";
import { ORDER_STATUS_STYLES } from "../../../utils/statusButtonStyleSelectors";
import { updateOrderStatus } from "../../../redux/slices/admin.slices/orders.slice";
import { useDispatch } from "react-redux";

interface OrderCardsProps {
  orders: ProductOrder[];
  setSelectedProductOrderId: (id: string) => void;
}

export const OrderCards = ({
  orders,
  setSelectedProductOrderId,
}: OrderCardsProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [openStatusMenu, setOpenStatusMenu] = useState<string | null>(null);
  const popupRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setOpenStatusMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {orders.map((order) => {
        const statusStyle = ORDER_STATUS_STYLES[order.status];

        return (
          <div
            key={order._id}
            className="relative rounded-xl shadow-lg p-5 bg-popupLight dark:bg-popupDark hover:shadow-xl transition cursor-pointer"
            onClick={() => setSelectedProductOrderId(order._id)}
          >
            <div className="flex justify-between items-start mb-3">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenStatusMenu(
                    openStatusMenu === order._id ? null : order._id
                  );
                }}
                className={`text-xs px-3 py-1 rounded-full font-medium cursor-pointer ${statusStyle.className}`}
              >
                {statusStyle.label}
              </span>
            </div>

            {openStatusMenu === order._id && (
              <div
                ref={popupRef}
                onClick={(e) => e.stopPropagation()}
                className="absolute z-20 mt-2 p-3 rounded-xl shadow-lg border bg-primaryBg dark:bg-primaryBgDark border-gray-200 dark:border-gray-700 flex flex-wrap gap-2 max-w-[220px]"
              >
                {Object.entries(ORDER_STATUS_STYLES).map(([status, config]) => (
                  <span
                    key={status}
                    onClick={() => {
                      dispatch(
                        updateOrderStatus({ _id: order._id, status }) as any
                      );
                      setOpenStatusMenu(null);
                    }}
                    className={`text-xs px-3 py-1 rounded-full font-medium cursor-pointer transition hover:scale-[1.05]
                        ${config.className}`}
                  >
                    {config.label}
                  </span>
                ))}
              </div>
            )}

            <p className="text-sm mb-1">
              <strong>{t("Date")}:</strong> {order.createdAt.split("T")[0]}
            </p>
            <p className="text-sm mb-1">
              <strong>{t("Quantity")}:</strong> {order.quantity}
            </p>
            <p className="text-sm">
              <strong>{t("Amount")}:</strong> ₹{order.price}
            </p>
          </div>
        );
      })}
    </div>
  );
};
